"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listAppBasePublishGateIssues = listAppBasePublishGateIssues;
const app_base_contract_1 = require("./app-base-contract");
const app_page_access_1 = require("./app-page-access");
function listAppBasePublishGateIssues(input) {
    const issues = [];
    const composition = input.composition;
    if (composition) {
        if (!(0, app_base_contract_1.appCompositionHasRootApp)(composition)) {
            issues.push({
                code: 'root_place_empty',
                nextStep: 'Mount an App Module at / or move a mounted App Module there.',
                message: 'No App Module is mounted at the root place / of the App.',
            });
        }
        else if (composition.mounts.length > 1 &&
            !input.artifact?.frame &&
            composition.mounts.some(mount => input.appDefinitions?.[mount.appId]?.frame)) {
            // Apps below the root place share the layout of one App.
            issues.push({
                code: 'shared_frame_missing',
                nextStep: 'Choose the App Module whose frame all pages share.',
                message: 'App Modules are mounted on two levels, but no App Module provides the shared frame of the App.',
            });
        }
    }
    // Saving allows up to the stored ceiling so a preview above the publish
    // limit works; publishing every delivery mode stays within the limit.
    const usage = (0, app_base_contract_1.appArtifactUsage)({ artifact: input.artifact });
    if (usage.bytes.used > usage.bytes.limit) {
        issues.push({
            code: 'artifact_bytes_limit_exceeded',
            nextStep: `Remove or shrink files until the App is at most ${(0, app_base_contract_1.formatAppBaseBytes)(usage.bytes.limit)}; the preview stays available.`,
            message: `App size ${(0, app_base_contract_1.formatAppBaseBytes)(usage.bytes.used)} exceeds the publish limit of ${(0, app_base_contract_1.formatAppBaseBytes)(usage.bytes.limit)}.`,
        });
    }
    if (usage.files.used > usage.files.limit) {
        issues.push({
            code: 'artifact_files_limit_exceeded',
            nextStep: `Remove files until the App has at most ${usage.files.limit}; the preview stays available.`,
            message: `App has ${usage.files.used} files; the publish limit is ${usage.files.limit}.`,
        });
    }
    const manifest = input.artifact?.manifest;
    if (!manifest || manifest.delivery.mode === 'internal_live')
        return issues;
    for (const route of manifest.routes) {
        if (!(0, app_page_access_1.appPageAudienceAccess)(input.pageAccess, route.path, 'public').active)
            continue;
        const routeSeo = manifest.routeSeo.find(item => item.routePath === route.path);
        if (!routeSeo) {
            issues.push({
                code: 'route_seo_missing',
                nextStep: 'Declare the App Module SEO contract and recompile its routeSeo before publishing.',
                routePath: route.path,
                message: `Public route ${route.path} has no SEO decision; recompile the App Module or declare routeSeo (indexable or explicit noindex).`,
            });
            continue;
        }
        if (routeSeo.indexableByDefault && routeSeo.metadataSource === 'none') {
            issues.push({
                code: 'route_seo_metadata_missing',
                nextStep: 'Bind route title and description to exposed fields, or declare this route noindex.',
                routePath: route.path,
                message: `Indexable public route ${route.path} has no SEO metadata source.`,
            });
        }
    }
    return issues;
}
